var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98923 1L8.76077 3.52103L8.23923 4.07739L6.38462 2.39089V8.72607H5.61538V2.44016L3.96462 4.06754L3.42 3.53089L5.98923 1ZM1.76923 10.242V5.69416H1V11H11V5.69416H10.2308V10.242H1.76923Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBlack);
export default __webpack_public_path__ + "static/media/upload-black.6d4cdf0a61af458158dded4ce7209036.svg";
export { ForwardRef as ReactComponent };